import AlertFill from '@/assets/icons/alert_fill.svg?component';
import CheckFill from '@/assets/icons/check_fill.svg?component';
import ForbidCircleFill from '@/assets/icons/forbid_circle_fill.svg?component';
import { Badge, type BadgeTone } from '@/components/atoms/Badge';
import { SvgIcon, type SvgIconProps } from '@/components/atoms/SvgIcon/SvgIcon';

export type StatusTone = 'good' | 'warn' | 'bad' | 'neutral';

const BADGE_TONE: Readonly<Record<StatusTone, BadgeTone>> = {
    good: 'success',
    warn: 'warning',
    bad: 'danger',
    neutral: 'neutral',
};

const ICON: Readonly<Record<Exclude<StatusTone, 'neutral'>, SvgIconProps['icon']>> = {
    good: CheckFill,
    warn: AlertFill,
    bad: ForbidCircleFill,
};

export interface StatusPillProps {
    tone: StatusTone;
    label: string;
    className?: string;
}

/**
 * A provider or pen status on the shared Badge, as LicenseStatusBadge does for licences: this
 * only maps the data sources' four tones to a Badge tone and icon. The label is the whole
 * text; the icon, or the dot of a neutral status, stays out of the accessibility tree.
 */
function StatusPill({ tone, label, className }: StatusPillProps) {
    return (
        <Badge
            tone={BADGE_TONE[tone]}
            size="md"
            className={className}
            dot={tone === 'neutral'}
            icon={
                tone === 'neutral' ? undefined : (
                    <SvgIcon icon={ICON[tone]} size="inherit" svgProps={{ 'aria-hidden': true }} />
                )
            }>
            {label}
        </Badge>
    );
}

export default StatusPill;
export { StatusPill };
